import { Info } from 'react-feather';
var Error = function (_a) {
    var message = _a.message;
    return (<div role="alert" className="mt-1.5 flex items-center gap-1.5 text-alert-danger">
      <Info size={18} className="flex-shrink-0"/>

      <div className="text-sm">{message}</div>
    </div>);
};
export default Error;
